import { render } from "./TableWithoutWrapper.vue?vue&type=template&id=626fe1a0"
import script from "./TableWithoutWrapper.vue?vue&type=script&lang=js"
export * from "./TableWithoutWrapper.vue?vue&type=script&lang=js"

import "./TableWithoutWrapper.vue?vue&type=style&index=0&id=626fe1a0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__